export const GET_ALL_CONFERENCES = 'GET_ALL_CONFERENCES'
export const GET_REPORT_DATA = 'GET_REPORT_DATA'
